import {Inject, Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApi, BASE_URL, Group, PagedResponse } from '@edl-development/edl-common';
import { EDLGroupForm } from '../model/edl-groups/edl-group-form.component';
import { EdlGroupAndPermissions } from '../groups/common/models/edl-group-and-permissions.model';
import { UpdateGroupsForUserModel } from '../groups/common/models/update-groups-for-user.model';
import { EdlGroupAndManagerPermissions } from '../groups/common/models/edl-group-and-manager-permissions.model';

@Injectable()
export class GroupApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    createGroup(group: EDLGroupForm) {
        return this.http.post(this.baseUri + '/Group', group);
    }

    getGroupsByPortal(portalId: number, offset?: number, limit?: number, orderBy?: string, ascending?: boolean, searchBy?: string, baseUrl?: string) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('orderBy', this.convertParam(orderBy))
            .append('ascending', String(ascending))
            .append('searchBy', this.convertParam(searchBy));

        return this.http.get<PagedResponse<EdlGroupAndManagerPermissions>>(this.baseUri + '/Groups/Portal/' + portalId.toString(), {
            params
        });
    }

    updateGroup(group: EDLGroupForm) {
        return this.http.put(this.baseUri + '/Group', group);
    }

    deleteGroup(group: Group) {
        return this.http.request<EdlGroupAndManagerPermissions>('delete', this.baseUri + '/Group', {
            body: group
        });
    }

    restoreGroup(group: Group) {
        return this.http.put<EdlGroupAndManagerPermissions>(this.baseUri + '/Group/Restore', group);
    }

    removeGroup(group: Group) {
        return this.http.request('delete', this.baseUri + '/Group/Remove', {
            body: group
        });
    }

    getGroupByGroupId(groupId: string) {
        return this.http.get(this.baseUri + '/Group/' + groupId);
    }

    getAllGroupsForPortal(){
        return this.http.get(this.baseUri + '/Groups');
    }

    getGroupsAndPermissions(userId: string) {
        return this.http.get<EdlGroupAndPermissions[]>(`${this.baseUri}/Groups/Permissions/${userId}`);
    }

    getUserGroupsByPortal(offset: number, limit: number, searchBy: string, role: string, group: string, building: string) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('searchBy', this.convertParam(searchBy))
            .append('role', this.convertParam(role))
            .append('group', this.convertParam(group))
            .append('building', this.convertParam(building));

        return this.http.get(this.baseUri + '/Groups/UserGroups', {
            params
        });
    }

    saveGroupAssignment(GroupID: string, UserId: any, selected: boolean): any {
        return this.http.put(this.baseUri + '/Group/Assignment/Update', {GroupID, UserId, selected}, { responseType: 'text' });
    }

    updateGroupsForUser(updates: UpdateGroupsForUserModel) {
        return this.http.put<Group[]>(`${this.baseUri}/Group/UpdateForUser`, updates);
    }

    uploadUsersForGroup(fileList: FileList, group: EDLGroupForm){
        let file: File = fileList[0];
        let formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('Group', JSON.stringify(group));

        return this.http.post(this.baseUri + '/Group/UploadUsers', formData);
    }

    // Volunteer Areas
    getVolunteerAreasByPortal(portalId: number, offset?: number, limit?: number, orderBy?: string, ascending?: boolean) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('orderBy', this.convertParam(orderBy))
            .append('ascending', String(ascending));

        return this.http.get<PagedResponse<EdlGroupAndManagerPermissions>>(this.baseUri + '/VolunteerAreas/Portal/' + portalId.toString(), {
            params
        });
    }
}